import type { LocationEditorProps } from './types'

import { ClickAwayListener, MenuList, Paper, Popper, Stack } from '@mui/material'
import { TextField } from '@workwave-tidal/core/components'

import { ActionBar } from './components/ActionBar'
import { LoadingCard } from './components/LoadingCard'
import { LocationAlert } from './components/LocationAlert'
import { LocationEditorListItem } from './components/LocationEditorListItem'
import { NoAssetsCard } from './components/NoAssetsCard'
import { Root } from './components/Root'
import { SetQueryCard } from './components/SetQueryCard'
import { useLocationEditor } from './hooks/useLocationEditor'

export function LocationEditor(props: LocationEditorProps) {
  const { queryMinLength } = props
  const {
    textFieldProps,
    rootProps,
    popperProps,
    paperProps,
    clickAwayProps,
    dropdownOptions,
    dropdownSelectedIndex,
    locationEditorListItemProps,
    menuListProps,
    cardType,
    actionBarProps,
  } = useLocationEditor(props)

  return (
    <ClickAwayListener {...clickAwayProps}>
      <Root {...rootProps}>
        <Stack direction="row" gap={0.5} alignItems="flex-start">
          <TextField {...textFieldProps} />

          <Popper {...popperProps}>
            <Paper {...paperProps}>
              {cardType === 'list' && (
                <MenuList {...menuListProps} data-testid="location-editor__asset-list__container">
                  {dropdownOptions.map((asset, index) => (
                    <LocationEditorListItem
                      key={asset.id}
                      asset={asset}
                      selected={dropdownSelectedIndex === index}
                      query={textFieldProps.value as string}
                      {...locationEditorListItemProps}
                    />
                  ))}
                </MenuList>
              )}
              {cardType === 'loading' && <LoadingCard />}
              {cardType === 'set-query' && <SetQueryCard queryMinLength={queryMinLength} />}
              {cardType === 'no-assets' && <NoAssetsCard />}
            </Paper>
          </Popper>

          <ActionBar {...actionBarProps} />
        </Stack>

        <LocationAlert {...props} />
      </Root>
    </ClickAwayListener>
  )
}
